import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { MARK_NO_SHOW, MARK_NO_SHOW_ERROR, MARK_NO_SHOW_SUCCESS } from '../../../actions.js';

function* markNoShow({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/marked_as_noshow`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      if (response?.data?.code == 4089) cogoToast.warn(response?.data?.message);
      else cogoToast.success(response?.data?.message);
      yield put({
        type: MARK_NO_SHOW_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: MARK_NO_SHOW_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: MARK_NO_SHOW_ERROR, payload: error });
  }
}

export function* watchmarkNoShow() {
  yield takeEvery(MARK_NO_SHOW, markNoShow);
}

function* markNoShowSaga() {
  yield all([fork(watchmarkNoShow)]);
}

export default markNoShowSaga;
